<template>
  <div>
    <table class="details-table" v-html="detailsHtml">

    </table>
  </div>
</template>

<script>
    import moment from 'moment';

    moment.locale('zh-cn');

    export default {
      name: "PrintDetailsInfo",
      // 制作打印模版组件时，props区域尽量保留。
      props: {
        detailsInfo: {
          type: Object,
          required: true,
          default:{}
        },
        // 每页多少行
        onePageRow: {
          type: Number,
          default: 5
        },
        // 是否插入空白行
        blankLines: {
          type: Boolean,
          default: true
        },
        getChineseNumber: Function // 求数字的中文写法，从easyPrint组件传入
      },
      data(){
        return{
          detailsHtml: ''
        }
      },
      watch:{
        detailsInfo: {
          handler: 'showDetailsInfo',
          deep: true,
          immediate: true
        }
      },
      methods:{
        moment,
        showDetailsInfo: function () {
          let participation = this.detailsInfo.unqualified + this.detailsInfo.qualified + this.detailsInfo.empty;
          let flag = this.detailsInfo.flag;
          let memNum = this.detailsInfo.memNum;
          if(flag){
            memNum = memNum * 2;
          }
          let qualified = this.detailsInfo.qualified;
          let unqualified = this.detailsInfo.unqualified;
          let empty = this.detailsInfo.empty;

          let participationRate = 0;
          let correctRate = 0;
          let nonCorrectRate = 0;
          let emptyRate = 0;
          if(memNum != 0){
            participationRate = Math.floor((participation/memNum)*10000)/100 +'%';
          }else {
            participationRate = '0%';
          }

          if(participation != 0){
            correctRate = Math.floor(((qualified+empty)/participation)*10000)/100 +'%';
            nonCorrectRate = Math.floor((unqualified/participation)*10000)/100 +'%';
            emptyRate = Math.floor((empty/participation)*10000)/100 + '%';
          }else {
            correctRate = '0%';
            nonCorrectRate = '0%';
            emptyRate = '0%';
          }

          let detailsHtml = '<tr>\n' +
            '          <td class="details-left">收集日期：</td>\n' +
            '          <td class="details-right">'+moment(new Date()).format('YYYY-MM-DD')+'</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">地址名称：</td>\n' +
            '          <td class="details-right">'+this.detailsInfo.address+'</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">垃圾重量：</td>\n' +
            '          <td class="details-right">'+Math.floor(this.detailsInfo.weightTotal*100)/100+' kg</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">参与户数：</td>\n' +
            '          <td class="details-right">'+participation+' 户</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">常驻户数：</td>\n' +
            '          <td class="details-right">'+this.detailsInfo.memNum+' 户</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">综合参与率：</td>\n' +
            '          <td class="details-right">'+participationRate+'</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">正确率：</td>\n' +
            '          <td class="details-right">'+correctRate+'</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">不正确率：</td>\n' +
            '          <td class="details-right">'+nonCorrectRate+'</td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '          <td class="details-left">空桶率：</td>\n' +
            '          <td class="details-right">'+emptyRate+'</td>\n' +
            '        </tr>';

          this.detailsHtml = detailsHtml;
        }
      },
      mounted() {

      }
    }
</script>

<style scoped>
  @page{
    size: auto A4 landscape;
    margin: 3mm;
  }
</style>



// WEBPACK FOOTER //
// src/views/datav/PrintDetailsInfo.vue